<div *ngIf="reconnecting" class="reconnecting-message alert alert-danger" role="alert">
  再接続しています。
</div>
